import "../css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./designSystem/Navbar";
import Footer from "./designSystem/Footer";
import ScrollToTop from "./designSystem/ScrollToTop";
import ScrollReveal from "./designSystem/ScrollReveal";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import ContactUsComponent from "./components/ContactUsComponent";
import AboutUsPage from "./pages/AboutUsPage";
import MortgagePage from "./pages/MortgagePage";
import PensionPage from "./pages/PensionPage.js";
import InvestmentsPage from "./pages/InvestmentsPage.js";
import PersonalFinancialAdvicePage from "./pages/PersonalFinancialAdvicePage.js";
import MortgageRepaymentPage from "./pages/MortgageRepaymentPage.js";
import MortgageBorrowPage from "./pages/MortgageBorrowPage.js";
import OverpaymentPage from "./pages/OverpaymentPage.js";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <ScrollReveal />
          <Navbar />
          {/* Navbar can be added here if needed */}
          {/* Define application routes */}
          <Routes>
            {/* Home page route */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/mortgages" element={<MortgagePage />} />
            <Route path="/pensions" element={<PensionPage />} />
            <Route path="/investments" element={<InvestmentsPage />} />
            <Route path="/financial-advice" element={<PersonalFinancialAdvicePage />} />
            <Route path="/calculators/mortgage-repayment" element={<MortgageRepaymentPage />} />
            <Route path="/calculators/mortgage-affordability" element={<MortgageBorrowPage />} />
            <Route path="/calculators/mortgage-overpayment" element={<OverpaymentPage />} />
            <Route path="/*" element={<LandingPage />} />
            
          </Routes>
          <ContactUsComponent />
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
